import { RegistrationRoutes } from '@/repository/auth';
const { NewRegistration } = RegistrationRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ }, { params, signature, expires, signedParams }) {
			try {
				return await NewRegistration(params, signature, expires, signedParams)
			}
			catch (error) {
				console.error('User could not be registered.', error);
				throw error;
			}
		}
	}
}